'use strict';

var lastEta,
	etaMethod,
	driver_activity,
	timeout_for_rest_poll = 30000,
	lastLocationUpdate = null,
	lastKnownLocation = null,
	locationFrames = [],
	lastETAUpdate = null,
	updateNow = false,
	counterSinceMapResize = 0,
	destination_lat,
	destination_lng,
	lastDriverLat,
	lastDriverLng,
	destination,
	receivingLocation = true,
	animationInterval = 50,
	MAX_LOCATION_POINTS_FOR_UPDATE = 500,
	io,
	google,
	socket,
	connected = false,
	configuration,
	etaFromServer = false,
	gettingLocationViaREST = false,
	isPushEnabled = false,
	isPendingRedirectFlow = false,
	REAL_TIME_URL = null,
	REAL_TIME_URL_PORT = null,
	callbacks = {
		locationUpateDb: null,
		etaUpateCb: null,
		etaMethodChangedCb: null,
		driverArrived: null,
		driverLeft: null,
		taskEnded: null,
		taskRated: null,
		failedLoading: null,
		noteAdded: null,
		taskPostRated: null,
		taskRescheduled: null
	};

/**
 * load env from query
 */
function setDispatcherToken() {
	var token = localStorage && localStorage.getItem('ls.auth_key');

	if (token) {
		$.ajaxSetup({
			beforeSend: function (xhr) {
				xhr.setRequestHeader('Authorization', JSON.parse(token));
			}
		});
	}
}

function getParameterByName(name) {
	var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
	return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getMonitorEndPoint() {
	return REAL_TIME_URL;
}

function getRegion(regionId) {
	if (regionId === null) {
		return null;
	}

	return Object.values(ENV_CONFIG.regions).find(function (region) {
		return region['id'] == regionId;
	});
}

function loadEnvConfig() {
	var regionNumber = getParameterByName('e');
	var envConfig = getRegion(regionNumber);

	envConfig = envConfig || ENV_CONFIG.regions[ENV_CONFIG['default_region']];
	REAL_TIME_URL = envConfig.real_time_url;
	REAL_TIME_URL_PORT = envConfig.socket_websocket_port;
	setDispatcherToken();
}

/**
 * add auto loader on ajax calls
 */

var totalAjaxInProgress = 0;
var visible = true;

function showLoader() {
	totalAjaxInProgress++;
	if (!visible && totalAjaxInProgress === 1) {
		visible = true;
		$('#loaderContainer').fadeToggle('slow', 'linear');
	}
}

function hideLoader() {
	totalAjaxInProgress--;
	if (visible && totalAjaxInProgress <= 0) {
		totalAjaxInProgress = 0;
		visible = false;
		$('#loaderContainer').fadeToggle('slow', 'linear');
	}
}

function setLoaderBackgroundColor(color) {
	$('#loaderContainer').css('background', color);
}

function guid() {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}

	return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function getETAMethod() {
	return etaMethod;
}

function setETAMethod(newETAMethod) {
	etaMethod = newETAMethod;
}

function _isSafari() {
	var ua = navigator.userAgent.toLowerCase();
	if (ua.indexOf('safari') !== -1) {
		return !(ua.indexOf('chrome') > -1);
	}
	return false;
}

function _isChrome() {
	var ua = navigator.userAgent.toLowerCase();
	return ua.indexOf('chrome') !== -1;
}

function isAndroid() {
	return navigator.userAgent.match(/Android/i);
}

function detectMobile() {
	return typeof window.orientation !== 'undefined';
}

function isIOS() {
	return navigator.userAgent.match(/iPhone|iPad|iPod/i);
}

function _supportsStorage() {
	try {
		localStorage.setItem('test', 'test');
		localStorage.removeItem('test');
		return 'localStorage' in window && window.localStorage !== null;
	} catch (e) {
		return false;
	}
}

function calculateAbsoluteETA() {
	var d = new Date();
	d.setMinutes(d.getMinutes() + lastEta);
	return d.toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' });
}

function initETAMethod() {
	if (configuration.consumer_app_eta_display) {
		etaMethod = configuration.consumer_app_eta_display.method;
	}
	if (etaMethod === 'smart') {
		var eta_smart_threshold = 30;
		if (!isNaN(configuration.consumer_app_eta_display.threshold)) {
			eta_smart_threshold = configuration.consumer_app_eta_display.threshold;
		}
		if (lastEta > eta_smart_threshold) {
			etaMethod = 'absolute';
			if (callbacks.etaMethodChangedCb) {
				callbacks.etaMethodChangedCb();
			}
		} else {
			etaMethod = 'countdown';
			if (callbacks.etaMethodChangedCb) {
				callbacks.etaMethodChangedCb();
			}
		}
		//default
	} else if (!etaMethod) {
		if (lastEta > 30) {
			etaMethod = 'absolute';
			if (callbacks.etaMethodChangedCb) {
				callbacks.etaMethodChangedCb();
			}
		} else {
			etaMethod = 'countdown';
			if (callbacks.etaMethodChangedCb) {
				callbacks.etaMethodChangedCb();
			}
		}
	} else {
		if (callbacks.etaMethodChangedCb) {
			callbacks.etaMethodChangedCb();
		}
	}
}

function getLastKnownETA() {
	if (etaFromServer) {
		return Math.floor((new Date(configuration.eta) - Date.now()) / 1000 / 60);
	}
	return lastEta;
}

function setLocationUpdateCb(cb) {
	callbacks.locationUpateDb = cb;
}

function setETAUpdateCb(cb) {
	callbacks.etaUpateCb = cb;
}

function setETAMethodChangedCb(cb) {
	callbacks.etaMethodChangedCb = cb;
}

function setEventCallback(addedCallbacks) {
	for (var callbackIdx in addedCallbacks) {
		if (callbacks[callbackIdx] === null) {
			callbacks[callbackIdx] = addedCallbacks[callbackIdx];
		}
	}
}

function setDriverActivity(newActivity) {
	driver_activity = google.maps.TravelMode.DRIVING;

	switch (newActivity) {
		case 1: //not moving
			driver_activity = google.maps.TravelMode.DRIVING;
			break;
		case 2: //walking
		case 3: //running
			driver_activity = google.maps.TravelMode.WALKING;
			break;
		case 4: // bicycle
			driver_activity = google.maps.TravelMode.BICYCLING;
			break;
		case 0: //unknown
		case 5: // driving
			driver_activity = google.maps.TravelMode.DRIVING;
			break;
		case 6: // public transport
			driver_activity = google.maps.TravelMode.TRANSIT;
			break;
	}
}

function customerAlert(options) {
	if (!configuration.alerting_token) {
		return;
	}

	var data = $.extend({}, { alert_type: 0, token: configuration.alerting_token }, options);

	$.post(configuration.alerting_url, data, function (response) {
		if (response.success) {
		} else {
		}
	}).fail(function () {
		console.error('Failed alerting');
	});
}

function calculateETA(originLat, originLng, destLat, destLng, destAddress, onETACalculatedCallback, travelMethod) {
	function callback(response, status) {
		if (response) {
			console.log('calculating ETA received (' + status + '): ', response.rows);
		}
		if (status === google.maps.DistanceMatrixStatus.OK) {
			var origins = response.originAddresses;
			var destinations = response.destinationAddresses;

			for (var i = 0; i < origins.length; i++) {
				var results = response.rows[i].elements;
				for (var j = 0; j < results.length; j++) {
					var element = results[j];
					if (['NOT_FOUND', 'ZERO_RESULTS'].indexOf(element.status) === -1) {
						//var distance = element.distance.text;
						var new_eta = Math.floor(element.duration.value / 60);
						console.log('calculating ETA got ETA: ' + new_eta);

						if (new_eta !== lastEta) {
							lastEta = new_eta;
							var from = origins[i];
							var to = destinations[j];
							if (onETACalculatedCallback) {
								onETACalculatedCallback(new_eta);
							}
							if (callbacks.etaUpateCb) {
								callbacks.etaUpateCb(lastEta);
							}
						}
					} else {
						console.log('calculating ETA received (' + element.status + ') no results');
						if (callbacks.etaUpateCb) {
							callbacks.etaUpateCb();
						}
					}
				}
			}
		} else {
			console.log('calculating ETA received error: ' + status);
			if (callbacks.etaUpateCb) {
				callbacks.etaUpateCb();
			}
		}
	}

	lastETAUpdate = new Date().getTime();

	var origin = new google.maps.LatLng(originLat, originLng),
		destination;

	console.log(
		'calculating ETA.. (' +
			originLat +
			',' +
			originLng +
			') to (' +
			destLat +
			',' +
			destLng +
			') driver_activity: (' +
			travelMethod || driver_activity + ')'
	);

	destLat = parseFloat(destLat);
	destLng = parseFloat(destLng);

	if (destLat && destLat !== 0 && destLng !== 0) {
		destination = new google.maps.LatLng(destLat, destLng);
	} else {
		destination = destAddress;
		console.log('calculating ETA from address: (' + destAddress + ')');
	}

	if (etaFromServer) {
		lastEta = getLastKnownETA();
		if (lastEta <= 1) {
			console.log('calculating ETA less than a minute, recalculating');
			etaFromServer = false;
			return calculateETA(originLat, originLng, destLat, destLng, destAddress, onETACalculatedCallback);
		}
		if (lastEta <= 10) {
			// 10 minutes away can start getting updated ETA without traffic
			console.log('calculating ETA less than a 10 minutes, not taking from server anymore');
			etaFromServer = false;
		}
		etaMethod = null;
		initETAMethod();
		if (onETACalculatedCallback) {
			onETACalculatedCallback();
		}
		if (callbacks.etaUpateCb) {
			callbacks.etaUpateCb(lastEta);
		}
	} else {
		var service = new google.maps.DistanceMatrixService();
		service.getDistanceMatrix(
			{
				origins: [origin],
				destinations: [destination],
				travelMode: travelMethod || driver_activity,
				unitSystem: google.maps.UnitSystem.METRIC,
				durationInTraffic: true
			},
			callback
		);
	}
}

function onLocationUpdated(data) {
	console.log('Got location update: ', data);
	if (data.lat && data.lng) {
		if (data.lat === 0 || data.lng === 0) {
			customerAlert({ alert_type: 2 });
		} else {
			lastLocationUpdate = new Date().getTime();
			var animationCounter = 30, // should be (time since last update / animationInterval)
				fromLocation = locationFrames[locationFrames.length - 1];

			if (!fromLocation) {
				if (lastKnownLocation) {
					fromLocation = lastKnownLocation;
				} else {
					fromLocation = new google.maps.LatLng(configuration.current_lat, configuration.current_lng);
				}
			}

			var fromLat = fromLocation.lat(),
				fromLng = fromLocation.lng(),
				previousCurrLng = fromLng,
				previouscurrLat = fromLat;

			console.log(
				'[ ' + new Date() + '] Going from ' + fromLat + ',' + fromLng + ' to ' + data.lat + ',' + data.lng
			);

			lastDriverLat = data.lat;
			lastDriverLng = data.lng;

			if (showingPanorama && panorama) {
				var heading = (Math.atan2(data.lng - fromLng, data.lat - fromLat) * 180) / Math.PI;
				panorama.setPosition({ lat: data.lat, lng: data.lng });
				panorama.setPov({ heading: heading, pitch: 0 });
			} else {
				for (var percent = 0; percent < 1; percent += 0.01) {
					var curLat = fromLat + percent * (data.lat - fromLat),
						curLng = fromLng + percent * (data.lng - fromLng);
					if (curLng !== previousCurrLng || curLat !== previouscurrLat) {
						locationFrames.push(new google.maps.LatLng(curLat, curLng));
						previousCurrLng = curLng;
						previouscurrLat = curLat;
					}
				}

				locationFrames.push(new google.maps.LatLng(data.lat, data.lng));

				if (lastETAUpdate === null) {
					calculateETA(data.lat, data.lng, destination_lat, destination_lng, destination, function () {
						customerAlert({ alert_type: 1, updated_eta: lastEta, driverActivity: driver_activity });
					});
				}
			}
		}
	} else {
		console.log('Empty location received');
	}
}

function onLocationSocketUpdated(data) {
	if (timeout_for_rest_poll < 30000) {
		customerAlert({ alert_type: 5, timeout_for_rest_poll: timeout_for_rest_poll });
		timeout_for_rest_poll = timeout_for_rest_poll + 5000;
	}
	onLocationUpdated(data);
}

function onSocketConnected() {
	connected = true;
	console.log('Socket connected, adding listeners');
	socket.on('activity change', function (data) {
		setDriverActivity(data.activity);
		updateNow = true;
	});

	socket.on('way point arrived', function (data) {
		console.log('way point arrived');

		if (isCustomerPickup(configuration)) {
			return;
		}

		receivingLocation = false;
		if (callbacks.driverArrived) {
			callbacks.driverArrived();
		}
	});

	var onWayPointCancelled = function (data) {
		console.log('task or way point cancelled');

		// check if the cancellation is part of the redirect flow
		if (!isPendingRedirectFlow) {
			onWayPointDone(data);
		}
	};

	var onWayPointDone = function (data) {
		console.log('task or way point done');
		socket.removeAllListeners();
		receivingLocation = false;

		if (configuration.allow_rating) {
			if (callbacks.driverLeft) {
				if (data && data.way_point && data.way_point.share_to_customer_notes) {
					configuration.share_to_customer_notes = data.way_point.share_to_customer_notes;
				}
				callbacks.driverLeft();
			}
		} else {
			if (callbacks.taskEnded) {
				callbacks.taskEnded();
			}
		}
	};

	var onWayPointEtaUpdated = function (data) {
		etaFromServer = true;
		configuration.eta = data.eta;
		lastEta = getLastKnownETA();
		if (callbacks.etaUpateCb) {
			callbacks.etaUpateCb(lastEta);
		}
	};

	var onWayPointLocationUpdated = function (data) {
		configuration.destination_lat = parseFloat(data.lat);
		configuration.destination_lng = parseFloat(data.lng);

		window.destinationLocation = new google.maps.LatLng(
			configuration.destination_lat,
			configuration.destination_lng
		);
		window.destinationMarker.setPosition(window.destinationLocation);
		window.resizeMapByMarkers(window.gmap, window.markerLocation, window.destinationLocation);
	};

	socket.on('way point done', onWayPointDone);
	socket.on('way point eta updated', onWayPointEtaUpdated);
	socket.on('way point location updated', onWayPointLocationUpdated);
	socket.on('order done', onWayPointDone);
	socket.on('order cancelled', onWayPointCancelled);

	socket.on('location update', onLocationSocketUpdated);
	console.log('Connecting.. subscribing task [' + configuration.order_uuid + '] share [' + configuration.uuid + ']');
	socket.emit(
		'watch order',
		{
			order_uuid: configuration.order_uuid,
			share_uuid: configuration.share_uuid,
			way_point_id: configuration.way_point_id
		},
		function (result) {
			if (result && result.expired) {
				console.log('share expired, not looking for location');
				configuration.expired = true;
			}
		}
	);
	socket.emit('watch driver', { share_uuid: configuration.uuid, driver_uuid: configuration.driver_uuid });
	socket.emit('watch way point', { order_uuid: configuration.order_uuid, way_point_id: configuration.way_point_id });
}

function connectSocket() {
	if (socket) {
		socket.removeListener('connect', onSocketConnected);
	}
	connected = false;
	console.log('Connecting to websocket at [' + configuration.monitor_url + ']');
	socket = io(
		/*configuration.monitor_url, {*/
		REAL_TIME_URL,
		{
			transports: ['websocket'],
			transportOptions: {
				websocket: {
					port: REAL_TIME_URL_PORT,
					secure: true
				}
			}
		}
	);
	socket.on('connect', onSocketConnected);
}

function sendReschedule(selectedDeliveryWindow, notificationOptions) {
	var payload = {
		delivery_window_id: selectedDeliveryWindow.id,
		start_time: selectedDeliveryWindow.start_time,
		end_time: selectedDeliveryWindow.end_time
	};

	if (notificationOptions) {
		payload.disable_email = notificationOptions.disable_email;
		payload.disable_phone = notificationOptions.disable_phone;
	}

	$.post(configuration.reschedule.reschedule_url, payload, function (response) {
		if (callbacks.taskRescheduled) {
			callbacks.taskRescheduled(response);
		}
	}).fail(function () {
		if (callbacks.taskRescheduled) {
			callbacks.taskRescheduled({ success: false, message: 'Unknown error while rescheduling' });
		}
	});
}

function sendCancelReschedule() {
	$.post(configuration.reschedule.cancel_url, {}, function (response) {
		if (callbacks.taskRescheduled) {
			callbacks.taskRescheduled(response);
		}
	}).fail(function () {
		if (callbacks.taskRescheduled) {
			callbacks.taskRescheduled({ success: false, message: 'Unknown error while rescheduling' });
		}
	});
}

function submitRating(rating) {
	var jqxhr = $.post(
		configuration.rating_url,
		{
			rating: rating,
			token: configuration.rating_token
		},
		function (response) {
			if (callbacks.taskRated) {
				callbacks.taskRated(response);
			}
		}
	).fail(function () {
		if (callbacks.taskRated) {
			callbacks.taskRated({ success: false, message: 'Unknown error while rating' });
		}
	});
}

function submitRatingReason(rating, ratingReasonId) {
	$.post(
		configuration.rating_reason.rating_reason_url,
		{
			rating: rating,
			rating_reason_id: ratingReasonId,
			token: configuration.rating_token
		},
		function (response) {
			if (callbacks.taskPostRated) {
				callbacks.taskPostRated(response);
			}
		}
	).fail(function () {
		if (callbacks.taskPostRated) {
			callbacks.taskPostRated({ success: false, message: 'Unknown error while submitting rating reason.' });
		}
	});
}

function submitNote(note) {
	if (!note) {
		return;
	}
	var jqxhr = $.post(
		configuration.note_url,
		{
			note: note,
			token: configuration.note_token
		},
		function (response) {
			if (callbacks.noteAdded) {
				callbacks.noteAdded(response);
			}
		}
	).fail(function () {
		if (callbacks.noteAdded) {
			callbacks.noteAdded({ success: false, message: 'Unknown error while sending note' });
		}
	});
}

function generateForwardShareLocation(params, cb) {
	var jqxhr = $.post(
		configuration.forward_url,
		$.extend(
			{
				uuid: configuration.uuid
			},
			params
		),
		function (response) {
			if (response.status === 'ok') {
				cb(response);
			} else {
				cb(response);
			}
		}
	).fail(function (reason) {
		cb(reason);
	});
}

function acceptForwarded(params, cb) {
	var jqxhr = $.post(
		configuration.forward_accept_url,
		$.extend(
			{
				uuid: configuration.uuid
			},
			params
		),
		function (response) {
			if (response.status === 'ok') {
				cb(response);
			} else {
				cb(response);
			}
		}
	).fail(function (reason) {
		cb(reason);
	});
}

function declineForwarded(params, cb) {
	var jqxhr = $.post(
		configuration.forward_decline_url,
		$.extend(
			{
				uuid: configuration.uuid
			},
			params
		),
		function (response) {
			if (response.status === 'ok') {
				cb(response);
			} else {
				cb(response);
			}
		}
	).fail(function (reason) {
		cb(reason);
	});
}

function dataURItoBlob(dataURI) {
	var binary = atob(dataURI.split(',')[1]);
	var array = [];
	for (var i = 0; i < binary.length; i++) {
		array.push(binary.charCodeAt(i));
	}
	return new Blob([new Uint8Array(array)], { type: 'image/jpeg' });
}

function submitLocation(position, successCb, failureCb) {
	$.post(configuration.find_me_url, {
		position: position,
		find_me_token: configuration.find_me_token
	})
		.success(function (response) {
			if (successCb) {
				successCb(response);
			}
		})
		.fail(function () {
			if (failureCb) {
				failureCb();
			}
		});
}

function getPhone(successCb, failureCb) {
	$.get(configuration.monitor_url + '/shared/' + configuration.share_uuid + '/phone_number', {})
		.success(successCb)
		.fail(failureCb);
}

function _loadScript(url, callback) {
	var done = false;
	var head = document.getElementsByTagName('head')[0];
	var script = document.createElement('script');
	script.src = url;
	script.crossorigin = 'anonymous';
	script.onload = script.onreadystatechange = function () {
		if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
			done = true;
			if (callback) {
				callback();
			}
			script.onload = script.onreadystatechange = null;
			head.removeChild(script);
		}
	};
	head.appendChild(script);
}

function initialiseState() {
	// Are Notifications supported in the service worker?
	if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
		return;
	}

	// Check the current Notification permission.
	// If its denied, it's a permanent block until the
	// user changes the permission
	if (Notification.permission === 'denied') {
		return;
	}

	// Check if push messaging is supported
	if (!('PushManager' in window)) {
		return;
	}

	// We need the service worker registration to check for a subscription
	navigator.serviceWorker.ready.then(function (serviceWorkerRegistration) {
		// Do we already have a push message subscription?
		serviceWorkerRegistration.pushManager
			.subscribe({ userVisibleOnly: true })
			.then(function (subscription) {
				if (!subscription) {
					// We aren't subscribed to push, so set UI
					// to allow the user to enable push
					return;
				}
				isPushEnabled = true;

				var endpointParts = subscription.endpoint.split('/'),
					pushToken = endpointParts[endpointParts.length - 1];

				// Keep your server in sync with the latest subscriptionId
				if (configuration.customer_uuid) {
					return $.post(
						configuration.monitor_url +
							'/shared/' +
							configuration.share_uuid +
							'/customer/' +
							configuration.customer_uuid +
							'/push_token',
						{ push_token: pushToken },
						function (response) {
							if (response.success) {
							} else {
							}
						}
					).fail(function () {
						console.error('Failed alerting');
					});
				}
			})
			.catch(function (err) {
				console.warn('Error during getSubscription()' + err);
			});
	});

	//addEventListener('push', function (event) {});
}

function initializeBringgAndGoogleMaps(ioLibrary, uuid, cb) {
	io = ioLibrary;
	var beforeCall = new Date();
	$.getJSON(REAL_TIME_URL + '/shared/' + uuid + '?full=true', function (updatedConfiguration) {
		$.getScript(updatedConfiguration.google_maps_url, function () {
			initializeBringg(updatedConfiguration, beforeCall, cb);
		}).error(function (jqXHR, textStatus, errorThrown) {
			if (callbacks.failedLoading) {
				callbacks.failedLoading(textStatus);
			}
		});
	}).error(function (jqXHR, textStatus, errorThrown) {
		if (callbacks.failedLoading) {
			callbacks.failedLoading(textStatus);
		}
	});
}

function initializeBringg(updatedConfiguration, beforeCall, cb) {
	if (detectMobile() && _isChrome() && 'serviceWorker' in navigator) {
		navigator.serviceWorker.register('/service-worker.js').then(initialiseState);
	}

	var afterCall = new Date() - beforeCall;
	configuration = updatedConfiguration;
	configuration.share_uuid = uuid;
	etaFromServer = configuration.eta ? true : false;
	if (etaFromServer) {
	}

	if (!(configuration.done && configuration.expired)) {
		destination_lat = configuration.destination_lat;
		destination_lng = configuration.destination_lng;
		destination = configuration.destination;
		initETAMethod();

		if (configuration.special_features) {
			configuration.special_features.forEach(function (special_feature) {
				if (special_feature.url) {
					_loadScript(special_feature.url, function () {});
				}
			});
		}
	}

	if (cb) {
		cb(configuration, google);
	}

	customerAlert({ alert_type: 7, time: afterCall });

	if (!configuration.expired) {
		setDriverActivity(configuration.driver_activity);

		connectSocket();

		setInterval(function () {
			var eta = 0;
			if (lastEta && lastETAUpdate && receivingLocation) {
				if (new Date().getTime() - lastETAUpdate > 1000 * 60) {
					console.log('Over a minute since eta update, recalculating ETA');
					if (etaFromServer) {
						eta = getLastKnownETA();
						if (eta <= 5) {
							console.log('(eta ' + eta + ') -> Not taking from server anymore');
							etaFromServer = false;
							updateNow = true;
						}
					} else {
						if (lastEta > 1) {
							eta = lastEta - 1;
						} else {
							//recalculate ETA here
							calculateETA(
								configuration.current_lat,
								configuration.current_lng,
								destination_lat,
								destination_lng,
								destination,
								function () {
									customerAlert({
										alert_type: 1,
										updated_eta: lastEta,
										driverActivity: driver_activity
									});
								}
							);
						}
					}
					if (callbacks.etaUpateCb) {
						callbacks.etaUpateCb(eta);
					}
				}
			}
		}, 1000 * 60);

		var locationUpdateInterval = setInterval(function () {
			if (!connected) {
				if (socket.socket) {
					try {
						socket.disconnect();
					} catch (e) {}
				}
				console.log('[' + new Date() + '] WS Disconnected for awhile, trying to connect');
				connectSocket();
			}

			if (lastLocationUpdate && receivingLocation) {
				var now = new Date().getTime(),
					timeSinceUpdate = now - lastLocationUpdate;
				if (timeSinceUpdate > timeout_for_rest_poll) {
					if (timeout_for_rest_poll > 10000) {
						timeout_for_rest_poll = timeout_for_rest_poll - 5000;
					}
					//there was no location update using WS, fetch location update using REST
					customerAlert({ alert_type: 4, last_update: timeSinceUpdate / 1000 });
					console.log('Getting location via REST fallback (' + timeSinceUpdate + ')');
					gettingLocationViaREST = true;
					$.getJSON(REAL_TIME_URL + '/shared/' + uuid + '/location/', function (data) {
						if (data.success && data.success === false && data.rc === 1) {
							console.log('Location expired, stopping polling');
							window.clearInterval(locationUpdateInterval);
							return;
						}
						var locationData = {
							lat: data.current_lat,
							lng: data.current_lng
						};
						onLocationUpdated(locationData);
					}).error(function (jqXHR, textStatus, errorThrown) {});
				}
			} else {
				lastLocationUpdate = new Date().getTime();
			}
		}, 5000);

		setTimeout(function () {
			if (lastETAUpdate === null) {
				calculateETA(
					configuration.current_lat,
					configuration.current_lng,
					destination_lat,
					destination_lng,
					destination,
					function () {
						customerAlert({ alert_type: 1, updated_eta: lastEta, driverActivity: driver_activity });
					}
				);
			}
		}, 3000);

		setInterval(function () {
			while (locationFrames.length > 2 * MAX_LOCATION_POINTS_FOR_UPDATE) {
				locationFrames.splice(0, MAX_LOCATION_POINTS_FOR_UPDATE - 1);
			}
			var nextLocation = locationFrames.shift();

			if (nextLocation === undefined) {
				return;
			}
			if (callbacks.locationUpateDb) {
				lastKnownLocation = nextLocation;
				callbacks.locationUpateDb(nextLocation);
			}
			counterSinceMapResize++;

			var now = new Date().getTime();
			if (
				now - lastETAUpdate > 10 * 60 * 1000 ||
				counterSinceMapResize > MAX_LOCATION_POINTS_FOR_UPDATE ||
				updateNow
			) {
				var alertOnActivityChange = updateNow;
				updateNow = false;
				console.log(
					'Updating ETA after timeout of (' +
						(now - lastETAUpdate) +
						') with (' +
						counterSinceMapResize +
						') and (' +
						updateNow +
						')'
				);
				calculateETA(
					nextLocation.lat(),
					nextLocation.lng(),
					destination_lat,
					destination_lng,
					destination,
					function () {
						if (alertOnActivityChange) {
							customerAlert({ alert_type: 1, updated_eta: lastEta, driverActivity: driver_activity });
						} else {
							customerAlert({ alert_type: 3, updated_eta: lastEta });
						}
					}
				);
				counterSinceMapResize = 0;
			}
		}, animationInterval);
	} else {
		receivingLocation = false;
	}
}

function getContrastYIQ(hexcolor) {
	var r = parseInt(hexcolor.substr(1, 2), 16);
	var g = parseInt(hexcolor.substr(3, 2), 16);
	var b = parseInt(hexcolor.substr(5, 2), 16);
	var yiq = (r * 299 + g * 587 + b * 114) / 1000;
	return yiq < 128 ? 'black' : 'white';
}

function getMarker(markerLocation, icon) {
	return new google.maps.Marker({
		position: markerLocation,
		optimized: false,
		map: gmap,
		icon: icon,
		animation: google.maps.Animation.DROP
	});
}

function optInClick() {
	sendOptInResponse(1);
}

function optOutClick() {
	sendOptInResponse(0);
}

function sendOptInResponse(opt_in) {
	var endPoint = configuration.opt_in_out_url;
	$.post(
		endPoint,
		{
			uuid: configuration.uuid,
			opt_in_out_token: configuration.opt_in_out_token,
			opt_in: opt_in
		},
		function (response) {
			if (response.success) {
				return showThankYouPage();
			}

			if (response.status === 'error') {
				return console.log(response.message);
			}
		}
	).fail(function (e) {
		console.log(e.message);
	});
}

function redirectOrderToPickUpLocation(team) {
	var data = { team_id: team.id };
	return new Promise(function (resolve, reject) {
		$.post(
			configuration.monitor_url + '/shared/redirect_delivery/' + configuration.share_uuid,
			data,
			function (response) {
				if (response.success) {
					resolve();
				} else {
					reject(response);
				}
			}
		).fail(function () {
			reject();
		});
	});
}

function updateRedirectFlowStatus(pending) {
	isPendingRedirectFlow = pending;
}

function sendETA(arrivalTime) {
	var data = {
		eta: arrivalTime.toISOString(),
		action_token: configuration.action_tokens && configuration.action_tokens.update_eta
	};
	return new Promise(function (resolve, reject) {
		$.post(configuration.monitor_url + '/shared/update_eta/' + configuration.share_uuid, data, function (response) {
			if (response.success) {
				resolve();
			} else {
				reject(response);
			}
		}).fail(function () {
			reject();
		});
	});
}

function customerCheckin() {
	var data = { action_token: configuration.action_tokens && configuration.action_tokens.checkin };
	return new Promise(function (resolve, reject) {
		$.post(configuration.monitor_url + '/shared/check_in/' + configuration.share_uuid, data, function (response) {
			if (response.success) {
				resolve(response);
			} else {
				reject(response);
			}
		}).fail(function () {
			reject();
		});
	});
}

function customerCheckout() {
	var data = { action_token: configuration.action_tokens && configuration.action_tokens.checkout };
	return new Promise(function (resolve, reject) {
		$.post(configuration.monitor_url + '/shared/check_out/' + configuration.share_uuid, data, function (response) {
			if (response.success) {
				resolve(response);
			} else {
				reject(response);
			}
		}).fail(function () {
			reject();
		});
	});
}

function isCustomerPickup(configuration) {
	return configuration.shared_type === 13;
}
